module.exports = __webpack_public_path__ + "img/step12.56283ff5.png";